export const ACCOUNT_PATHS = {
	ROOT: "/account",
	LOGIN: "/account/login",
	LOGOUT: "/account/logout",
	REGISTER: "/account/register",
	FORGOT_PASSWORD: "/account/forgot-password",
	CHANGE_PASSWORD: "/account/change-password",
	RESET_PASSWORD: "/account/reset-password",
};

export const ACCOUNT_TABS = {
	PROFILE: "profile",
	ORDERS: "orders",
};

export const ACCOUNT_ACTIVE_TAB_KEY = "tab";

export const ACTIVE_MOBILE_ORDER_CONTAINER = "activeMobileOrder";
